import React, { useEffect, useState } from "react";
import "./header.scss";
import CompanyLogo from "../../assets/VEDHAS AI/01 (1).png";
import { Link, NavLink } from "react-router-dom";
export default function Header() {
  const [scroll, setScroll] = useState(false);
  const [open, setOpen] = useState(false);

  const handleOnClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    function handleScroll() {
      if (window.scrollY > 15) {
        setScroll(true);
      } else {
        setScroll(false);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <header className={`${scroll ? "scroll" : ""}`}>
      <div className="container">
        <div className="header-grid">
          <div className="header-logo">
            <Link to="/" onClick={handleOnClose}>
              <img src={CompanyLogo} alt="Vedhas AI Technologies" />
            </Link>
          </div>
          <nav className="header-menu">
            <NavLink
              to="/blog"
              style={({ isActive }) => ({
                color: isActive ? "#c36bd6" : "",
                background: isActive
                  ? "linear-gradient(110.61deg, rgba(195, 107, 214, 0.2) -10.33%, rgba(88, 63, 187, 0.3) 120.46%)"
                  : "",
                textDecoration: "none",
              })}
            >
              Blogs
            </NavLink>
            <NavLink
              to="/services"
              style={({ isActive }) => ({
                color: isActive ? "#c36bd6" : "",
                background: isActive
                  ? "linear-gradient(110.61deg, rgba(195, 107, 214, 0.2) -10.33%, rgba(88, 63, 187, 0.3) 120.46%)"
                  : "",
                textDecoration: "none",
              })}
            >
              Services
            </NavLink>
            <NavLink
              to="/contact"
              style={({ isActive }) => ({
                color: isActive ? "#c36bd6" : "",
                background: isActive
                  ? "linear-gradient(110.61deg, rgba(195, 107, 214, 0.2) -10.33%, rgba(88, 63, 187, 0.3) 120.46%)"
                  : "",
                textDecoration: "none",
              })}
            >
              Contact
            </NavLink>
            <NavLink
              to="/about"
              style={({ isActive }) => ({
                color: isActive ? "#c36bd6" : "",
                background: isActive
                  ? "linear-gradient(110.61deg, rgba(195, 107, 214, 0.2) -10.33%, rgba(88, 63, 187, 0.3) 120.46%)"
                  : "",
                textDecoration: "none",
              })}
            >
              About
            </NavLink>
            <NavLink
              to="/product"
              style={({ isActive }) => ({
                color: isActive ? "#c36bd6" : "",
                background: isActive
                  ? "linear-gradient(110.61deg, rgba(195, 107, 214, 0.2) -10.33%, rgba(88, 63, 187, 0.3) 120.46%)"
                  : "",
                textDecoration: "none",
              })}
            >
              Product
            </NavLink>
          </nav>
          <div className="hamburger" onClick={() => setOpen(!open)}>
            <svg
              stroke="#c36bd6"
              fill="none"
              stroke-width="2"
              viewBox="0 0 24 24"
              aria-hidden="true"
              height="30"
              width="30"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M4 6h16M4 12h16M4 18h7"
              ></path>
            </svg>
          </div>
          <div className="login-button">
            <button title="Login">Login</button>
            <p title="Sign Up">Sign Up</p>
          </div>
        </div>
        <div
          className={`mobile_menu ${open ? "open" : ""} ${
            scroll ? "set_top" : ""
          }`}
        >
          {/* <div className="close" onClick={handleOnClose}>
            <svg
              stroke="currentColor"
              fill="currentColor"
              stroke-width="0"
              viewBox="0 0 512 512"
              height="26px"
              width="26px"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="m289.94 256 95-95A24 24 0 0 0 351 127l-95 95-95-95a24 24 0 0 0-34 34l95 95-95 95a24 24 0 1 0 34 34l95-95 95 95a24 24 0 0 0 34-34z"></path>
            </svg>
          </div> */}
          <div className="menu_item">
            <NavLink
              to={"/blog"}
              style={({ isActive }) => ({
                color: isActive ? "#fff" : "white",
                background: isActive
                  ? "linear-gradient(110.61deg, rgba(195, 107, 214, 0.2) -10.33%, rgba(88, 63, 187, 0.3) 120.46%)"
                  : "",
              })}
              onClick={handleOnClose}
            >
              <p>Blogs</p>
            </NavLink>
            <NavLink
              to={"/services"}
              style={({ isActive }) => ({
                color: isActive ? "#fff" : "white",
                background: isActive
                  ? "linear-gradient(110.61deg, rgba(195, 107, 214, 0.2) -10.33%, rgba(88, 63, 187, 0.3) 120.46%)"
                  : "",
              })}
              onClick={handleOnClose}
            >
              <p>Services</p>
            </NavLink>
            <NavLink
              to={"/contact"}
              style={({ isActive }) => ({
                color: isActive ? "#fff" : "white",
                background: isActive
                  ? "linear-gradient(110.61deg, rgba(195, 107, 214, 0.2) -10.33%, rgba(88, 63, 187, 0.3) 120.46%)"
                  : "",
              })}
              onClick={handleOnClose}
            >
              <p>Contact</p>
            </NavLink>
            <NavLink
              to={"/about"}
              style={({ isActive }) => ({
                color: isActive ? "#fff" : "white",
                background: isActive
                  ? "linear-gradient(110.61deg, rgba(195, 107, 214, 0.2) -10.33%, rgba(88, 63, 187, 0.3) 120.46%)"
                  : "",
              })}
              onClick={handleOnClose}
            >
              <p>About</p>
            </NavLink>
            <NavLink
              to={"/product"}
              style={({ isActive }) => ({
                color: isActive ? "#fff" : "white",
                background: isActive
                  ? "linear-gradient(110.61deg, rgba(195, 107, 214, 0.2) -10.33%, rgba(88, 63, 187, 0.3) 120.46%)"
                  : "",
              })}
              onClick={handleOnClose}
            >
              <p>Product</p>
            </NavLink>
          </div>
        </div>
      </div>
    </header>
  );
}
